import { useAccessToken } from "./use-access-token";
import { useUserData } from "./use-user-data";

// TODO: implement refresh token logic
export const useIsAuthenticated = () => {
  const [accessToken] = useAccessToken();
  const [userData] = useUserData();

  if (userData === null || accessToken === null) {
    return false;
  }

  return true;
};
